import { render, staticRenderFns } from "./TheSideBar.vue?vue&type=template&id=5a2a226a&scoped=true&"
import script from "./TheSideBar.vue?vue&type=script&lang=js&"
export * from "./TheSideBar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2a226a",
  null
  
)

export default component.exports